import { render, staticRenderFns } from "./ResourcesFolderView.vue?vue&type=template&id=ebd49af6&scoped=true"
import script from "./ResourcesFolderView.vue?vue&type=script&lang=js"
export * from "./ResourcesFolderView.vue?vue&type=script&lang=js"
import style0 from "./ResourcesFolderView.vue?vue&type=style&index=0&id=ebd49af6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd49af6",
  null
  
)

export default component.exports